import { useState, useEffect, useCallback } from "react";
import { format } from "date-fns";
import { Space, Table } from "antd";
import { LogItem } from "../../model/model";
import SessionStore from "../../model/SessionStore";

interface IProps {
  deviceId: string;
  metricsLimit: number;
  startDate: Date;
  endDate: Date;
}

function DeviceLogs(props: IProps) {
  const [deviceLogs, setDeviceLogs] = useState<LogItem[] | undefined>(undefined);

  const loadDeviceLogs = useCallback(() => {
    SessionStore.getClient().getDeviceLogs(props.deviceId, props.metricsLimit, props.startDate.getTime(), props.endDate.getTime(), SessionStore.getBearer()).then((resp) => {
      setDeviceLogs(resp.data);
    }).catch((error) => {
      console.error('Error loading device logs:', error);
      setDeviceLogs([]);
    });
  }, [props.deviceId, props.metricsLimit, props.startDate, props.endDate]);

  useEffect(() => {
    loadDeviceLogs();
  }, [loadDeviceLogs]);

  return (
    <Space direction="vertical" style={{ width: "100%" }} size="large">
      <Table<LogItem>
        dataSource={deviceLogs}
        rowKey="time"
        columns={[
          { title: 'Time', dataIndex: 'time', render: (time: number) => format(new Date(time), 'yyyy-MM-dd HH:mm:ss') },
          { title: 'Device ID', dataIndex: 'devId' },
          { title: 'Data', dataIndex: 'data' },
        ]}
        pagination={false}
      />
    </Space>
  );
}

export default DeviceLogs;